import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMsal } from "@azure/msal-react";
import '../styles/newProject.css';
import { uploadToBlob } from '../utils/blobStorage';

function NewProject() {
  const { accounts } = useMsal();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    shortDescription: '',
    fullDescription: ''
  });
  const [files, setFiles] = useState([]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    setFiles(selectedFiles);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      // Create project in database
      const response = await fetch(`/api/updateUser/${accounts[0]?.localAccountId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          operation: 'addProject',
          data: {
            id: Date.now().toString(),
            name: formData.name,
            description: formData.shortDescription,
            files: [
              {
                id: Date.now().toString() + '-input',
                name: 'input.docx'
              },
              ...files.map(file => ({
                id: Date.now().toString() + '-' + file.name,
                name: file.name
              }))
            ]
          }
        })
      });

      if (!response.ok) throw new Error('Failed to create project');
      
      const userData = await response.json();
      const newProject = userData.projects[userData.projects.length - 1];

      // Save input document
      const inputContent = `Project Details\n\nName: ${formData.name}\n\nShort Description: ${formData.shortDescription}\n\nFull Description:\n${formData.fullDescription}`;
      
      await uploadToBlob(
        inputContent,
        'input.docx',
        newProject.id
      );

      // Upload additional files
      for (const file of files) {
        await uploadToBlob(
          file,
          file.name,
          newProject.id
        );
      }

      // Navigate to the new project
      navigate(`/project?project=${newProject.id}`);
    } catch (error) {
      console.error('Error creating project:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="new-project-container">
      <form className="new-project-form" onSubmit={handleSubmit}>
        <h2 className="form-title">Create New Project</h2>
        
        <div className="form-group">
          <label className="form-label" htmlFor="name">Project Name</label>
          <input
            type="text"
            id="name"
            name="name"
            className="form-input"
            value={formData.name}
            onChange={handleInputChange}
            required
          />
        </div>

        <div className="form-group">
          <label className="form-label" htmlFor="shortDescription">Short Description</label>
          <input
            type="text"
            id="shortDescription"
            name="shortDescription"
            className="form-input"
            value={formData.shortDescription}
            onChange={handleInputChange}
            required
          />
        </div>

        <div className="form-group">
          <label className="form-label" htmlFor="fullDescription">Full Description</label>
          <textarea
            id="fullDescription"
            name="fullDescription"
            className="form-textarea"
            value={formData.fullDescription}
            onChange={handleInputChange}
            required
          />
        </div>

        <div className="form-group">
          <label className="form-label" htmlFor="files">Upload Files (Optional)</label>
          <input
            type="file"
            id="files"
            name="files"
            className="form-input"
            onChange={handleFileChange}
            multiple
          />
        </div>

        <div className="form-actions">
          <button 
            type="button" 
            className="button button-secondary"
            onClick={() => navigate('/dashboard')}
          >
            Cancel
          </button>
          <button 
            type="submit" 
            className="button button-primary"
            disabled={isLoading}
          >
            {isLoading ? 'Creating...' : 'Create Project'}
          </button>
        </div>
      </form>
    </div>
  );
}

export default NewProject; 